import { fetcher } from '@commenda/utils';

export async function linkCredentialToBusinessEntity(
  businessEntityId: number,
  credentialId: string
) {
  const response = await fetcher(
    `business-entities/${businessEntityId}/credentials/${credentialId}`,
    {
      method: 'POST',
    }
  );

  return response;
}
